export function getParams (state){
    return state.params
}




// WEBPACK FOOTER //
// ./src/modules/vouchers-types/getters.js